export const HEADER_MOBILE_HEIGHT = 53;

export const HEADER_DESKTOP_HEIGHT = 80;

export const FOOTER_DESKTOP_HEIGHT = 50;

export const FOOTER_MOBILE_HEIGHT = 110;
